export default "__VITE_ASSET__C3zzF2EW__"